import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'form',
    'question',
    'questionNumberTitle',
    'questionNumberInput',
    'questionRemoveButton',
    'totalPoint',
    'point',
  ];

  static values = {
    mediaCompletionTestFormPath: String,
  };

  connect() {
    this.calcTotalPoint();
  }

  async typeChanged() {
    const formData = new FormData(this.formTarget);
    formData.set('_method', 'POST');

    const response = await fetch(this.mediaCompletionTestFormPathValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
      body: formData,
    });

    const html = await response.text();
    window.Turbo.renderStreamMessage(html);
  }

  toggleRemoveButton() {
    const allowRemove = this.questionTargets.length > 1;

    this.questionRemoveButtonTargets.forEach(e => e.hidden = !allowRemove); 
  }

  removeQuestion(event) {
    if (confirm("設題を削除しますか？")) {
      this.questionTargets.at(
        this.questionRemoveButtonTargets.indexOf(event.target)
      ).remove();
    }
  }

  questionTargetConnected() {
    this.setQuestionNumber();
    this.toggleRemoveButton();

    if (this.questionTargets.length > 1) {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }
  }

  questionTargetDisconnected() {
    this.setQuestionNumber();
    this.toggleRemoveButton();
    this.calcTotalPoint();
  }

  calcTotalPoint() {
    if (!this.hasTotalPointTarget) return;

    this.totalPointTarget.textContent = this.pointTargets.reduce((acc, e) => acc + Number(e.value), 0);
  }

  setQuestionNumber() {
    this.questionTargets.forEach((_e, i) => {
      this.questionNumberTitleTargets.at(i).textContent = i + 1;
      this.questionNumberInputTargets.at(i).value = i + 1;
    });
  }
}
